import { Inject, Injectable } from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';
import { EnvironmentToken } from '../../environment/enviroment-token';
import { I18nKeys } from './i18n-keys';

interface I18nKeysOut {
  [key: string]: string | object;
}

@Injectable({
  providedIn: 'root'
})
export class CommonsTranslationService {
  /*
  initialize i18ns with all the object keys so the compiler can catch
  new keys added to I18nKeys interface (Cards lib)
   */

  i18nKeys: I18nKeys = {
    add: '',
    address: {
      line1: '',
      line2: '',
      line3: '',
      line4: '',
      latitude: '',
      longitude: '',
      locality: '',
      town: '',
      county: '',
      state: '',
      country: '',
      postCode: ''
    },
    addressNotFound: '',
    back: '',
    browseFiles: '',
    clickHere: '',
    closeBtn: '',
    dropToUpload: '',
    dropFilesHere: '',
    enterAddressManually: '',
    file: '',
    fileTooLarge: '',
    fileTypeNotAllowedError: '',
    isRequired: '',
    lookupAddress: '',
    next: '',
    no: '',
    noResultsFound: '',
    ok: '',
    cancel: '',
    retry: '',
    percentComplete: '',
    required: '',
    selectedAddress: '',
    start: '',
    submit: '',
    upload: '',
    uploading: '',
    uploadImage: '',
    uploadInProgress: '',
    uploadImageError: '',
    uploadTooLargeMultiple: '',
    viewDocument: '',
    yes: '',
    yourLocation: '',
    dataLogging: {
      label: '',
      hint: ''
    },
    video: {
      confirmDeletion: '',
      record: '',
      maximumLengthHint: ''
    },
    email: {
      body: '',
      from: '',
      subject: '',
      to: ''
    },
    help: {
      label: '',
      title: '',
      submitLabel: '',
      preSubmitMessage: '',
      postSubmitMessage: '',
      invalidEmail: '',
      firstName: '',
      lastName: '',
      email: '',
      phoneNumber: '',
      comment: ''
    },
    aiValidation: {
      remove: '',
      quality: '',
      detection: '',
      warnings: '',
      dimensions: '',
      overallScore: '',
      sharpness: '',
      exposure: '',
      resolution: '',
      issues: '',
      equipmentType: '',
      confidence: '',
      boundingBoxes: '',
      show: '',
      hide: '',
      showBoundingBoxes: '',
      hideBoundingBoxes: '',
      imageSize: '',
      sourceSize: '',
      validationSuccessful: '',
      qualityIssues: '',
      lowConfidence: '',
      noDetection: '',
      validating: '',
      validationFailed: '',
      imageValidationSuccessful: '',
      imageQualityIssues: '',
      lowConfidenceDetection: '',
      noEquipmentDetected: '',
      imageValidationInProgress: '',
      imageValidationFailed: '',
      equipmentDetectedSuccessfully: '',
      imageTooLowQuality: '',
      equipmentDetectedLowConfidence: '',
      noEquipmentInImage: '',
      analyzingImage: '',
      validationFailedMessage: '',
      qualityCheckingImage: '',
      equipmentFound: '',
      qualityTooLowMessage: '',
      lowConfidenceMessage: '',
      noEquipmentDetectedMessage: '',
      validationFailedFor: '',
      confidenceWarning: '',
      reassuranceMessage: '',
      qualityIssuesLabel: '',
      detectionIssuesLabel: '',
      fuseCutout: '',
      consumerUnit: '',
      isolatorSwitch: '',
      unknown: '',
      equipment: '',
      failedToValidateImage: ''
    }
  };

  i18ns: I18nKeysOut = {
    add: '',
    address: {
      line1: '',
      line2: '',
      line3: '',
      line4: '',
      latitude: '',
      longitude: '',
      locality: '',
      town: '',
      county: '',
      state: '',
      country: '',
      postCode: ''
    },
    addressNotFound: '',
    back: '',
    browseFiles: '',
    clickHere: '',
    closeBtn: '',
    dropToUpload: '',
    dropFilesHere: '',
    enterAddressManually: '',
    file: '',
    fileTooLarge: '',
    fileTypeNotAllowedError: '',
    isRequired: '',
    lookupAddress: '',
    next: '',
    no: '',
    noResultsFound: '',
    ok: '',
    cancel: '',
    retry: '',
    percentComplete: '',
    required: '',
    selectedAddress: '',
    start: '',
    submit: '',
    upload: '',
    uploading: '',
    uploadImage: '',
    uploadInProgress: '',
    uploadImageError: '',
    uploadTooLargeMultiple: '',
    viewDocument: '',
    yes: '',
    yourLocation: '',
    video: {
      confirmDeletion: '',
      record: '',
      maximumLengthHint: ''
    },
    email: {
      body: '',
      from: '',
      subject: '',
      to: ''
    },
    help: {
      label: '',
      title: '',
      submitLabel: '',
      preSubmitMessage: '',
      postSubmitMessage: '',
      invalidEmail: '',
      firstName: '',
      lastName: '',
      email: '',
      phoneNumber: '',
      comment: ''
    }
  };

  constructor(private translocoService: TranslocoService, @Inject(EnvironmentToken) private environment: any) {}

  loadTranslations() {
    this.i18ns = this.loadTranslationParts(this.i18ns);
    if (!this.environment.production) {
      console.log('\x1b[34m%s\x1b[0m', 'Commons translations: ', this.i18ns);
    }
    return this.i18ns as unknown as I18nKeys;
  }

  private loadTranslationParts(keys: Partial<I18nKeysOut>, path: string | null = null) {
    Object.entries(keys).forEach(([key, value]) => {
      if (typeof value === 'string') {
        keys[key] = this.translocoService.translate(path ? `_commons.${path}.${key}` : `_commons.${key}`);
      } else {
        if (!keys[key]) {
          keys[key] = {};
        }
        this.loadTranslationParts(keys[key] as object, path ? `${path}.${key}` : key);
      }
    });
    return keys as unknown as I18nKeysOut;
  }
}
